var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","width":"100%","min-width":"100%","height":"28rem","min-height":"28rem"}},[_c('v-img',{attrs:{"src":require('@/assets/hipster_job_eyecatch.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }